import { useQuery } from 'react-query';
import { getWorkouts } from 'queries/workouts';
import { WorkoutResponse } from '@solin-fitness/types';

export const useGetWorkouts = () =>
  useQuery<WorkoutResponse[]>('workouts', async () => await getWorkouts(), {
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
  });
